// extracted by mini-css-extract-plugin
export default {"heroBanner":"RoadmapsWelcomePage_heroBanner__XeH3d"};